var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 815,
    height: 1000,
    viewBox: "0 0 815 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M776.438 140.021C751.14 97.3673 716.87 63.3917 673.776 38.0938C631.122 12.6489 583.762 0 531.696 0H0V147.669H531.696C569.201 147.669 601.118 160.759 627.298 187.086C653.626 212.825 666.716 244.301 666.716 281.365V719.518C666.716 756.141 653.626 787.322 627.298 813.061C600.971 838.8 569.201 851.743 531.696 851.743H148.404V296.22H0V851.449L148.551 1000H531.696C583.762 1000 631.122 987.645 673.776 962.789C716.87 937.491 751.14 903.662 776.438 861.45C801.736 819.238 814.385 772.614 814.385 721.43V281.071C814.385 229.004 801.736 181.939 776.438 139.726V140.021Z",
    fill: "#FFAE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigD);
export default __webpack_public_path__ + "static/media/bigD.b9160c9200c7e1c940c103c15f9d8d77.svg";
export { ForwardRef as ReactComponent };